export default {"src":"/_next/static/media/TAG2.d3a4203c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};